import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { StudyNavigationService } from '../../services/study-navigation.service';
import { InstructionService } from '../../services/instruction.service';

@Component({
  selector: 'app-continue-button',
  templateUrl: './continue-button.component.html',
  styleUrls: ['./continue-button.component.scss'],
})
export class ContinueButtonComponent implements OnInit {
  @Input('label') label: string;
  @Input('route') route: string = '';
  @Output('onClick') onClick = new EventEmitter();

  constructor(
    private navigation: StudyNavigationService,
    private instructionService: InstructionService
  ) {}

  ngOnInit(): void {
    if (!this.label) {
      this.label = this.instructionService.getTranslationsForTerm(
        'INSTRUCTION_CONTINUE_BUTTON'
      );
    }
  }

  navigateToNext() {
    this.onClick.emit();
    this.navigation.renderNext();
  }
}
